import { lazy, Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectLicense } from '~/components/brand/ducks/selectors.js';
import {
	selectForceUsernamePassword,
	selectOneBankIDFlowEnabled,
	selectOneButtonFlowEnabled
} from '~/store/feature-toggles/onboarding-feature-toggles';
import { LICENSE_SGA, LICENSE_KSA, LICENSE_OGA } from '~/utils/license-utils.js';
import useRegistration from './use-register.js';

const RegisterSGA = lazy(() => import(/* webpackChunkName: "register-sga" */ './register-sga.js'));

const RegisterKSA = lazy(() => import(/* webpackChunkName: "register-sga" */ './register-ksa.tsx'));

const RegisterWizard = lazy(() => import(/* webpackChunkName: "register-wizard" */ './registration-wizard.js'));

const RegisterWizardOnboarding = lazy(() => import(/* webpackChunkName: "register-oga" */ './new-register/index'));

const SuspenseWrapper = ({ children }) => <Suspense fallback={<div className="spinner" />}>{children}</Suspense>;

const RegisterComponentMap = {
	[LICENSE_SGA]: RegisterSGA,
	[LICENSE_KSA]: RegisterKSA,
	[LICENSE_OGA]: RegisterWizardOnboarding
};

const Register = ({ campaignRegistration }) => {
	const license = useSelector(selectLicense);
	const forceNormalRegistration = useSelector(selectForceUsernamePassword);

	const RegisterComponent = forceNormalRegistration
		? RegisterWizard
		: (RegisterComponentMap[license] ?? RegisterWizard);

	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlowEnabled);
	const isPlayNowEnabled = oneBankIDFlowEnabled || oneButtonFlow;
	const { redirectToRegister } = useRegistration();
	// moved this redirection from auth-gateway
	// for franchises that moved from full registration to one button flow, redirect to the correct registration flow
	useEffect(() => {
		if (isPlayNowEnabled) {
			redirectToRegister();
		}
	}, [isPlayNowEnabled, redirectToRegister]);

	if (isPlayNowEnabled) {
		return <div className="spinner" />;
	}
	return (
		<SuspenseWrapper>
			<RegisterComponent campaignRegistration={campaignRegistration} />
		</SuspenseWrapper>
	);
};

export default Register;
